<script setup lang="ts">
import ConfirmationModal from './ConfirmationModal.vue';
//#region globals
const { state, dispatch } = useStore();
//#endregion

//#region Confirmation modal
const confirmModalData = computed(() => state.modal?.confirmModalData);
const showConfirmModal = computed(() => state.modal?.showConfirmModal);

const confirming = ref(false);

async function handleConfirmation() {
   try {
      confirming.value = true;
      if (confirmModalData.value?.onConfirm) {
         await confirmModalData.value.onConfirm();
      }
   } finally {
      dispatch('modal/closeConfirmation');
      confirming.value = false;
   }
}

function handleClose() {
   try {
      if (confirmModalData.value?.onCancel) {
         confirmModalData.value.onCancel();
      }
   } finally {
      dispatch('modal/closeConfirmation');
   }
}
//#endregion
</script>

<template>
   <Transition name="fade">
      <ConfirmationModal
         v-if="showConfirmModal"
         :title="confirmModalData?.title"
         :cancel-text="confirmModalData?.cancelText"
         :confirm-text="confirmModalData?.confirmText"
         @confirm="handleConfirmation"
         @close="handleClose"
      />
   </Transition>
</template>
